<style lang="less">
@import '@/components/ai/zzl/zzl-ai-workbench.less';
.pdf-export {
  .markdown-body h1 {
    margin-top: 0 !important;
  }
}
</style>
<template>
  <div class="zzl-view-page" style="height:100%;overflow:hidden;position:relative;display:flex;flex-direction:column;min-height:0;">
    <div class="flex-wrap flex-between" style="flex-shrink:0;height:50px;padding:0 10px;background:linear-gradient(to right,#fff,var(--border));">
      <div class="flex-wrap split5" style="align-items:center;flex-wrap:wrap;gap:8px;">
        <div class="flex-wrap" style="white-space:nowrap;align-items:center;">
          平台
          <Select v-model="platform" style="margin-left:5px;width:120px;" @on-change="getProjectData()">
            <Option v-for="p in platforms" :key="p.key" :value="p.key">{{ p.name }}</Option>
          </Select>
        </div>
        <Select
          v-model="selectedProjects"
          multiple
          filterable
          clearable
          placeholder="选择项目（不选表示所有在建项目）"
          style="width:400px;"
          :max-tag-count="2"
          @on-change="getProjectData()"
        >
          <Option v-for="p in projects" :key="p.id" :value="p.id" :label="p.name">
            {{ p.name }}
            <Tag>{{ p.finished ? '已完成' : '进行中' }}</Tag>
            <Tag v-if="p.group">{{ p.group }}</Tag>
          </Option>
        </Select>
      </div>
      <div class="flex-wrap flex-right" style="gap:8px;">
        <Button class="zzl-view-top-refresh" type="default" @click="getProjects">刷新列表</Button>
        <Button @click="CopyToClip" v-if="aiText" type="warning">复制数据</Button>
        <Button v-if="aiText" type="default" icon="md-download" @click="downloadDataFile">下载数据文件</Button>
        <Button @click="CopyAttachmentsToClip" v-if="images.length > 0 || files.length > 0">复制附件信息</Button>
      </div>
    </div>

    <div class="zzl-view-split" style="flex:1;min-height:0;border-top:1px solid var(--border);">
      <div class="zzl-view-left" style="padding:12px;display:flex;flex-direction:column;min-height:0;">
        <Spin v-if="loading" fix size="large">
          <div class="zzl-view-data-loading-text">加载数据中…</div>
        </Spin>
        <div class="zzl-view-left-half zzl-view-left-half--data">
          <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:8px;flex-shrink:0;">
            <div class="zzl-view-section-title" style="margin:0;">数据下载和清理</div>
            <div class="flex-wrap" style="align-items:center;gap:8px;">
              <Button type="primary" icon="md-download" :loading="loading" @click="getProjectData">获取数据</Button>
              <Button type="warning" @click="CopyToClip">复制数据</Button>
              <Button type="default" icon="md-download" :disabled="!aiText" @click="downloadDataFile">下载数据文件</Button>
            </div>
          </div>
          <div class="zzl-view-left-toolbar" style="margin-bottom:8px;flex-shrink:0;">
            <div class="flex-wrap" style="align-items:center;flex-wrap:wrap;gap:8px;">
              <Button type="default" size="small" @click="applyPresetPrompt">应用预设：纳入通用模板分析</Button>
              <Button @click="CopyAttachmentsToClip" v-if="images.length > 0 || files.length > 0">复制附件信息</Button>
              <span style="font-size:12px;color:var(--subtext2);">字符数 {{ aiText.length }}</span>
            </div>
          </div>
          <div class="zzl-view-left-textarea-wrap">
            <Input
              type="textarea"
              :value="aiText"
              :rows="6"
              style="width:100%;flex:1;min-height:0;font-family:inherit;white-space:pre-wrap;"
              readonly
              placeholder="点击「获取数据」后此处显示层级数据"
            />
          </div>
        </div>
        <div class="zzl-view-left-half zzl-view-left-half--prompt">
          <div class="zzl-view-left-prompt-body">
            <AiPromptPanel
              v-model="userText"
              mod="zzl-untemplated"
              :textarea-rows="4"
              :hide-mod-hint="true"
              split-head
            >
              <template slot="head-left">
                <div class="zzl-view-section-title flex-wrap" style="margin:0;align-items:baseline;gap:8px;">
                  提示词
                  <span style="font-size:12px;font-weight:400;color:var(--subtext2);">
                    （{{ labelForMod('zzl-untemplated') }} · zzl-untemplated）
                  </span>
                </div>
              </template>
            </AiPromptPanel>
          </div>
        </div>
      </div>

      <div class="zzl-view-right" style="padding:10px;display:flex;flex-direction:column;min-height:0;">
        <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:6px;">
          <div class="zzl-view-section-title" style="margin:0;">报告</div>
          <div class="zzl-view-right-actions flex-wrap" style="gap:8px;justify-content:flex-end;margin-left:auto;">
            <Button type="primary" icon="md-play" :loading="ai_executings" :disabled="aiText.length < 10" @click="CreateByAI">
              {{ ai_executings ? '生成中…' : (result ? '重新生成' : '生成报告') }}
            </Button>
            <Button v-if="images.length" @click="copyImageAddresses">复制图片地址</Button>
            <Button @click="copyReportMd" :disabled="!result">复制 Markdown</Button>
            <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
            <AiSaveToKnowledgeButton :content="result" :disabled="!result || ai_executings" :file-name="zzlSaveFileName" />
          </div>
        </div>
        <div class="zzl-view-right-report">
          <AiMarkdownStreamPanel
            ref="reportPanel"
            class="pdf-export"
            style="flex:1;min-height:0;"
            :value="result"
            :streaming="ai_executings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
moment.locale('zh-cn');
import zzlAiStreamReport from '@/components/ai/zzl/mixins/zzlAiStreamReport';
import AiPromptPanel from '@/components/ai/AiPromptPanel.vue';
import AiMarkdownStreamPanel from '@/components/ai/AiMarkdownStreamPanel.vue';
import {labelForMod} from '@/components/ai/aiPromptModLabels';
import { buildZzlPdfFileStem } from '@/components/ai/zzl/zzl-report-filename';

const PRESET_PROMPT_TEMPLATE = `【应用场景】根据多项目的自建任务数据，统计高频任务并给出模版化管理建议。

请先忽略无意义的、测试类的任务（如：测试、试运行、临时、demo、示例、占位等），再基于下方「项目-模块-阶段-工作包-任务」层级数据完成分析：

1. **多项目对比与高频统计**  
   统计在多个项目中重复出现的任务（可按任务名称或业务含义归类），列出高频任务及出现次数/项目数，便于识别共性工作。

2. **建议纳入模版化管理的任务及理由**  
   在以上统计基础上，明确建议纳入通用模板管理的具体任务（或任务类型），并逐条说明理由（如：多项目普遍存在、表述一致、可标准化、便于管控等）。

输出请结构清晰、结论明确，便于后续决策与模板维护。`;

const INDENT = '    ';

function normalizeTask(t) {
  return {
    ...t,
    projectName: t.projectName || '未知项目',
    module: t.module || '默认模块',
    stage: t.stage || '',
    workpackage: t.workpackage || '',
    jobNode: t.jobNode || '',
  };
}

function buildHierarchyText(tasks) {
  const normalized = tasks.map(normalizeTask);
  const byProject = {};
  normalized.forEach((task) => {
    const p = task.projectName;
    if (!byProject[p]) byProject[p] = {};
    const mod = task.module;
    if (!byProject[p][mod]) byProject[p][mod] = {};
    const st = task.stage;
    if (!byProject[p][mod][st]) byProject[p][mod][st] = {};
    const wp = task.workpackage;
    if (!byProject[p][mod][st][wp]) byProject[p][mod][st][wp] = [];
    byProject[p][mod][st][wp].push(task);
  });

  const lines = [];
  Object.keys(byProject).sort().forEach((projectName) => {
    let projectTaskIndex = 0;
    lines.push(projectName);
    const byMod = byProject[projectName];
    Object.keys(byMod).sort().forEach((module) => {
      lines.push(INDENT + module);
      const byStage = byMod[module];
      Object.keys(byStage).sort().forEach((stage) => {
        lines.push(INDENT + INDENT + (stage || '(未分组)'));
        const byWp = byStage[stage];
        Object.keys(byWp).sort().forEach((workpackage) => {
          lines.push(INDENT + INDENT + INDENT + (workpackage || '(未分组)'));
          byWp[workpackage].forEach((task) => {
            projectTaskIndex += 1;
            lines.push(INDENT + INDENT + INDENT + INDENT + `[${projectTaskIndex}] ${task.jobNode}`);
          });
        });
      });
    });
  });
  return lines.join('\n');
}

export default {
  components: { AiPromptPanel, AiMarkdownStreamPanel },
  mixins: [zzlAiStreamReport],
  data() {
    return {
      platform: 'pmis',
      platforms: [
        { key: 'pmis', name: '项管' },
        { key: 'jlis', name: '监理' },
        { key: 'jgis', name: '监管' },
      ],
      projects: [],
      selectedProjects: [],
      tasks: [],
      aiText: '',
      userText: PRESET_PROMPT_TEMPLATE,
      loading: false,
      images: [],
      files: [],
      extractForm: false,
      onlyQuestion: false,
      ai_executings: false,
      result: '',
    };
  },
  mounted() {
    this.$api.afterLogin(() => {
      this.getProjects();
    });
  },
  methods: {
    labelForMod,
    zzlReportPdfStem() {
      const plat = (this.platforms.find((p) => p.key === this.platform) || {}).name || this.platform;
      const count = (this.selectedProjects || []).length;
      const projLabel = count ? `${count}个项目` : '全部在建';
      return buildZzlPdfFileStem(['自建任务', plat, projLabel]);
    },
    getProjects() {
      this.$api.get('logined_zzl/projects?q=all').then((res) => {
        this.projects = res.data.data || [];
      });
    },
    getProjectData() {
      this.loading = true;
      const params = {
        platform: this.platform,
      };
      if (this.selectedProjects && this.selectedProjects.length > 0) {
        params.projects = this.selectedProjects;
      }
      this.$api.post('logined_zzl/get_project_untemplated_tasks', params).then((res) => {
        this.tasks = res.data.data || [];
        this.cleanData();
      }).catch((e) => {
        this.Error('获取数据失败');
        console.error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    cleanData() {
      if (!this.tasks || this.tasks.length === 0) {
        this.aiText = '暂无数据';
        this.images = [];
        this.files = [];
        return;
      }
      this.aiText = buildHierarchyText(this.tasks);
    },
    applyPresetPrompt() {
      this.userText = PRESET_PROMPT_TEMPLATE;
      this.Success('已应用预设提示词');
    },
    async CopyToClip() {
      const text = this.aiText || '';
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
        }
        this.Success('复制成功');
        return true;
      } catch (err) {
        console.error('复制失败:', err);
        this.Error('复制失败');
        return false;
      }
    },
    async CopyAttachmentsToClip() {
      const text = this.images.map((v) => `![${v.name || '图片'}](${v.url || v})`).join('\n') + this.files.map((v) => `[${v.name || '附件'}](${v.url || v})`).join('\n');
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        }
        this.Success('复制成功');
        return true;
      } catch (err) {
        console.error('复制失败:', err);
        this.Error('复制失败');
        return false;
      }
    },
  },
};
</script>

<style>
.image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5px;
  width: 200px;
  height: 170px;
}
.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.image-label {
  font-size: 12px;
  color: #666;
  text-align: center;
}
</style>
